// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tyD_","rootMobile":"styles_rootMobile__3ikDq"};